import * as types from 'store/actions/types';
import services from 'services/services';
import i18next from 'i18next';
import { openNotification } from 'components/utilities/notification/notification';

// Import helpers
import { checkErrorStatus } from 'store/helpers/error_status';

// ******************** FETCH USER PRODUCTS ********************
export const fetchUserProducts = () => async (dispatch) => {
	try {
		dispatch({
			type: types.FETCH_USER_PRODUCTS_LOADING,
			payload: true
		});

		const { data } = await services.get('subscriber/products');

		dispatch({
			type: types.FETCH_USER_PRODUCTS_SUCCESS,
			payload: data.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_USER_PRODUCTS_ERROR,
			payload: true
		});

		checkErrorStatus(error) &&
			openNotification({
				type: 'error',
				title: i18next.t('common_products_error_title'),
				description: i18next.t('common_products_error_description')
			});
	}
};
